import overapi from "../../../../assets/img/programming/overapi.webp";
import python from "../../../../assets/img/programming/python.webp";
import w3schools from "../../../../assets/img/programming/w3schools.webp";
import devhints from "../../../../assets/img/programming/devhints.webp";
import cheatography from "../../../../assets/img/programming/cheatography.webp";
import devdocs from "../../../../assets/img/programming/devdocs.webp";
import pythoncheat from "../../../../assets/img/programming/pythoncheat.webp";
import realpython from "../../../../assets/img/programming/realpython.webp";
import zeal from "../../../../assets/img/programming/zeal.webp";

export const DataDoc = [
  {
    title: "OverAPI",
    path: "https://overapi.com/python",
    icon: overapi,
    cName: "icon",
    description: "Collecting All Cheat Sheets. Big cheatsheets ressources.",
  },
  {
    title: "Python Cheatsheet",
    path: "https://www.pythoncheatsheet.org/",
    icon: pythoncheat,
    cName: "icon",
    description:
      "This is a basic cheatsheet for Python mostly based on the book written by Al Sweigart, Automate the Boring Stuff with Python under the Creative Commons license and many other sources.",
  },
  {
    title: "Devhints",
    path: "https://devhints.io/python",
    icon: devhints,
    cName: "icon",
    description: "This is a collection of cheatsheets. Thanks to Rico.",
  },
  {
    title: "Python (Official)",
    path: "https://www.python.org/doc/",
    icon: python,
    cName: "icon",
    description: "Official documentation of Python.",
  },
  {
    title: "Cheatography",
    path: "https://cheatography.com/tag/python/",
    icon: cheatography,
    cName: "icon",
    description:
      "Over 3,500 Free Cheat Sheets, Revision Aids and Quick References. You can create yours.",
  },
  {
    title: "DevDocs",
    path: "https://devdocs.io/python~3.8/",
    icon: devdocs,
    cName: "icon",
    description:
      "DevDocs combines multiple API documentations in a fast, organized, and searchable interface. It can be used Offline.",
  },
  {
    title: "Real Python",
    path: "https://realpython.com/documenting-python-code/",
    icon: realpython,
    cName: "icon",
    description:
      "Welcome to your complete guide to documenting Python code. Whether you’re documenting a small script or a large project, whether you’re a beginner or seasoned Pythonista, this guide will cover everything you need to know.",
  },
  {
    title: "W3schools",
    path: "https://www.w3schools.com/python/default.asp",
    icon: w3schools,
    cName: "icon",
    description:
      "W3Schools is an educational website for learning web technologies online. Content includes tutorials and references.",
  },
  {
    title: "Zeal",
    path: "https://zealdocs.org/",
    icon: zeal,
    cName: "icon",
    description:
      "Zeal is an offline documentation browser for software developers. Zeal comes with 200 awesome docsets.",
  },
];
